<mat-form-field class="commom-mat-select" [ngClass]="{ 'commom-mat-select-admin' : isAdmin }">

  <mat-select placeholder="" panelClass="{{matPanelName}}" formControlName="{{formControlFieldName}}"
    id="{{formControlFieldName}}" [multiple]="displayMultiple" (selectionChange)="sendToParent($event.value)"
    [ngClass]="{ 'mat-select-admin' : isAdmin }">

    <input class="form-control key-search" type="text" placeholder="Filter by keywords" *ngIf="searchBar"
      [(ngModel)]="searchKey" [ngModelOptions]="{standalone: true}"
      (input)="onInputSearchChange($event.target.value)" />

    <div class="select-all" *ngIf="displayMultiple">
      <mat-checkbox class="custom-frame" [checked]="isChecked()" [indeterminate]="isIndeterminate()"
        (click)="$event.stopPropagation()" (change)="toggleSelection($event)">
        ALL
      </mat-checkbox>
    </div>

    <mat-select-trigger *ngIf="displayAll && !searchBar">
      <span class="bold">ALL</span>
    </mat-select-trigger>

    <mat-option *ngFor="let o of options" [value]="o">{{ o[keyValue] }}</mat-option>

  </mat-select>
</mat-form-field>